// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".invitesListItem_player__yRlPA {\n  position: relative;\n  display: flex;\n  justify-content: left;\n  align-items: center;\n  height: 100%;\n  width: 80%;\n  padding-left: 5px;\n  cursor: pointer;\n}\n\n.invitesListItem_username__2k4nC {\n  padding-right: 3px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.invitesListItem_avatar__1X2hz {\n  width: 24px;\n  height: 24px;\n}", ""]);
// Exports
exports.locals = {
	"player": "invitesListItem_player__yRlPA",
	"username": "invitesListItem_username__2k4nC",
	"avatar": "invitesListItem_avatar__1X2hz"
};
module.exports = exports;
